export const CURRENCY_SYMBOLS = {
  XAF: "FCFA", XOF: "CFA", NGN: "\u20a6", GHS: "GH\u20b5", KES: "KSh",
  ZAR: "R", USD: "$", EUR: "\u20ac", GBP: "\u00a3",
};
export const ZERO_DECIMAL = new Set(["XAF", "XOF"]);

export function money(n, currency = "XAF") {
  if (n === null || n === undefined || isNaN(n)) return "\u2014";
  const cur = currency || "XAF";
  const sym = CURRENCY_SYMBOLS[cur] || cur;
  const dec = ZERO_DECIMAL.has(cur) ? 0 : 2;
  const num = new Intl.NumberFormat("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(n);
  if (cur === "XAF" || cur === "XOF") return `${num} ${sym}`;
  return `${sym}${num}`;
}

export function fcfa(n) {
  return money(n, "XAF");
}

export function shortDate(iso) {
  if (!iso) return "\u2014";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export const STATUS_STYLES = {
  OPEN: "bg-amber-100 text-amber-800 border-amber-200",
  IN_PROGRESS: "bg-blue-100 text-blue-800 border-blue-200",
  PLANNED: "bg-stone-200 text-stone-700 border-stone-300",
  COMPLETED: "bg-emerald-100 text-emerald-800 border-emerald-200",
  CANCELLED: "bg-stone-200 text-stone-600 border-stone-300",
  PAID: "bg-emerald-100 text-emerald-800 border-emerald-200",
  UNPAID: "bg-red-100 text-red-800 border-red-200",
  PARTIAL: "bg-amber-100 text-amber-800 border-amber-200",
  SENT: "bg-blue-100 text-blue-800 border-blue-200",
  APPROVED: "bg-emerald-100 text-emerald-800 border-emerald-200",
  REJECTED: "bg-red-100 text-red-800 border-red-200",
  ACTIVE: "bg-emerald-100 text-emerald-800 border-emerald-200",
  LOW: "bg-stone-100 text-stone-700 border-stone-200",
  MEDIUM: "bg-amber-100 text-amber-800 border-amber-200",
  HIGH: "bg-orange-100 text-orange-800 border-orange-200",
  CRITICAL: "bg-red-100 text-red-800 border-red-200",
};

export const PRODUCTS = {
  BUILD: { label: "Walo BUILD", desc: "Unfinished buildings", color: "bg-[hsl(197,37%,40%)]" },
  TRANSFORM: { label: "Walo TRANSFORM", desc: "Renovation & interior", color: "bg-[hsl(15,75%,62%)]" },
  CARE: { label: "Walo CARE", desc: "Recurring management", color: "bg-[hsl(142,39%,25%)]" },
};

export function healthColor(score) {
  if (score >= 80) return "hsl(142 39% 35%)";
  if (score >= 60) return "hsl(43 74% 45%)";
  return "hsl(0 72% 51%)";
}
